import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider, useAuth } from "./Context/AuthContext";
import { Provider } from "react-redux";
import store, { persistor } from './Redux/Store';
import { PersistGate } from "redux-persist/integration/react";
import SingleTabBlock from "./Utils/SingeTabBlock";

// Create a separate component that can use the AuthContext
const TabLockWrapper = ({ children }) => {
    const [isTabLocked, setIsTabLocked] = useState(false);
    const [isLockHolder, setIsLockHolder] = useState(false);
    const channel = new BroadcastChannel("app-tab-lock");
    
    const { authUser, isInitialized } = useAuth();
    const isAuthenticated = !!authUser;
    
    // Only allow these paths to open in multiple tabs for unauthenticated users
    const allowedRoutes = ['/', '/anonymouseCmpRegistration'];
    const currentPath = window.location.pathname;

    useEffect(() => {
        // If user is not authenticated OR current route is allowed, skip locking logic
        if (!isAuthenticated || allowedRoutes.includes(currentPath)) {
            return;
        }

        let timeoutId;
        let isMounted = true;

        channel.postMessage("check-lock");

        timeoutId = setTimeout(() => {
            if (isMounted) {
                setIsLockHolder(true);
                channel.postMessage("lock-acquired");
            }
        }, 500);

        const handleMessage = (event) => {
            if (event.data === "lock-acquired" && isMounted) {
                clearTimeout(timeoutId);
                setIsTabLocked(true);
            }

            if (event.data === "check-lock" && isLockHolder) {
                channel.postMessage("lock-acquired");
            }
        };

        channel.addEventListener("message", handleMessage);

        return () => {
            isMounted = false;
            clearTimeout(timeoutId);
            channel.removeEventListener("message", handleMessage);
        };
    }, [isLockHolder, currentPath, isAuthenticated]);

    // Wait for auth to initialize
    if (!isInitialized) {
        return <div>Loading...</div>; // Or your loading component
    }

    // 🔐 Block UI only if user is authenticated AND path is restricted
    if (isAuthenticated && isTabLocked && !allowedRoutes.includes(currentPath)) {
        return <SingleTabBlock />;
    }

    return children;
};

const AppWrapper = () => {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <AuthProvider>
                    <TabLockWrapper>
                        <Router>
                            <App />
                            <ToastContainer />
                        </Router>
                    </TabLockWrapper>
                </AuthProvider>
            </PersistGate>
        </Provider>
    );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <AppWrapper />
    </React.StrictMode>
);

reportWebVitals();